import { isAiConversationType } from '@lyrahealth-inc/shared-app-logic/src/features/messaging/utils'
import { CONVERSATION_TYPE } from '@lyrahealth-inc/shared-app-logic/src/models/messages/Messages'

export const getAiConversationMixpanelProperties = (conversationType?: CONVERSATION_TYPE) =>
  isAiConversationType(conversationType) ? { conversation_type: conversationType } : {}
